import { getAllUrlParams } from './appUtils';
import { Base64 } from './encrypt';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-community/async-storage';

export const redirections = async props => {
  let urlParams = getAllUrlParams(window.location.href);

  switch (props.page.toLowerCase()) {
    case 'transactiondetails':
      props.makeAPICall(
        props.api({}, props.service),
        response => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.reference_no
          ) {
            let product = response.data.account_type;
            props.navigation.state.params = {};
            props.navigation.state.params.flow = true;
            props.navigation.state.params.name = product;
            props.navigation.navigate(
              'transactionDetails',
              props.navigation.state.params
            );
          } else {
            props.navigation.navigate('errorpage');
          }
        },
        err => {
          if (err.code !== 499) {
            props.navigation.navigate('errorpage');
          }
        }
      );
      break;

    case 'errorpage':
      if (Platform.OS === 'web') {
        sessionStorage.removeItem('token');
        sessionStorage.setItem('token', urlParams.lead_id);
      } else {
        await AsyncStorage.removeItem('token');
        await AsyncStorage.setItem('token', urlParams.lead_id);
      }

      let product = Base64.atob(urlParams.account_type);
      props.navigation.state.params = {};
      props.navigation.state.params.flow = true;
      props.navigation.state.params.name = product;
      props.navigation.navigate(
        'transactionFailed',
        props.navigation.state.params
      );
      break;
  }
};
